<ng-container *ngIf="!loading">
  <h3>Upload File</h3>
  <ngx-file-drag-drop [formControl]="expenseCodesFile" [multiple]="false"></ngx-file-drag-drop>
  <mat-dialog-actions fxLayout="row" fxLayoutGap="5pt" fxLayoutAlign="end center">
    <button mat-button type="button" color="warn" [mat-dialog-close]="false">
      <mat-icon class="material-icons-outlined">cancel</mat-icon>
      Exit
    </button>
    <button [disabled]="!expenseCodesFile.valid" mat-button type="submit" color="accent" (click)="uploadExpenseCodes()">
      <mat-icon class="material-icons-outlined">check_circle</mat-icon>
      Submit
    </button>
  </mat-dialog-actions>
</ng-container>
<div fxLayout="row" fxLayoutAlign="center center">
  <ng-container *ngIf="loading">
    <app-loading [isRelative]="true"></app-loading>
  </ng-container>
</div>
